<div class="flag-selector">
  <orbit-context-menu [items]="items()" (itemClicked)="selectColor($event)" />
</div>
